import { apiRequest } from './client';

export function searchRevenueProducts(token, params = {}) {
  const query = new URLSearchParams(params).toString();
  return apiRequest(`/admin/revenue-calculator${query ? `?${query}` : ''}`, token);
}

export function calculateRevenue(token, payload) {
  return apiRequest('/admin/revenue-calculator', token, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function calculateRevenueBulk(token, payload) {
  return apiRequest('/admin/revenue-calculator/bulk', token, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
